var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLaptop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-laptop-7499602 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.2646 27.1203L39.1694 31.7033C39.5513 32.6238 39.4491 33.6753 38.8962 34.5031C38.3432 35.3324 37.4116 35.831 36.4145 35.831H8.70958C7.71243 35.831 6.7824 35.3324 6.22788 34.5031C5.67495 33.6737 5.57268 32.6238 5.95462 31.7033L7.85942 27.1203V22.1952C7.85942 21.4905 8.43309 20.9168 9.13783 20.9168C9.84417 20.9168 10.4162 21.4905 10.4162 22.1952V26.3148H34.706V12.3946C34.706 12.1597 34.5159 11.968 34.2809 11.968H10.8429C10.608 11.968 10.4178 12.1597 10.4162 12.3946V15.3781C10.4162 16.0829 9.84413 16.6565 9.13779 16.6565C8.43305 16.6565 7.85938 16.0829 7.85938 15.3781V12.3946C7.85938 10.7471 9.19531 9.41113 10.8429 9.41113H34.2809C35.9285 9.41113 37.2628 10.7471 37.2628 12.3946V27.1203H37.2646ZM9.90175 28.8717L8.31652 32.6845C8.26219 32.8156 8.27657 32.9658 8.35487 33.084C8.43317 33.2023 8.56741 33.2742 8.70963 33.2742H36.4145C36.5567 33.2742 36.6894 33.2023 36.7693 33.084C36.8476 32.9658 36.8635 32.8156 36.8076 32.6845L35.2224 28.8717H9.90175Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptop);
export default __webpack_public_path__ + "static/media/Laptop.512fbe030ed3c01d7cb2fd266e87b7a0.svg";
export { ForwardRef as ReactComponent };